import { IScraperJobConfigurationMetadataFragment } from 'apps/spot-quote-control-panel/graphql/ScraperJobConfigurationMetadataFragment'
import { useScraperJobConfigurationMetadataQuery } from '../graphql/ScraperJobConfigurationMetadata'

interface IJobConfigMetadata {
  metadata: IScraperJobConfigurationMetadataFragment
  metadataLoading: boolean
}

export const useJobMetadata = () => {
  const { data, loading } = useScraperJobConfigurationMetadataQuery()
  const { scraperJobConfigurationMetadata } = data || {}
  return {
    metadata: scraperJobConfigurationMetadata as IScraperJobConfigurationMetadataFragment,
    metadataLoading: loading,
  } as IJobConfigMetadata
}
